import { RouteObject } from 'react-router-dom'
import NewInvoiceRoute from './NewInvoiceRoute'

const basePath = 'invoices2'

export const invoicesRoutes = (): RouteObject[] => [
  {
    path: basePath,
    children: [{ path: 'new', element: <NewInvoiceRoute /> }]
  }
]

export const invoicePaths = {
  new: () => `/${basePath}/new`
}
